import Button from "../button/Button";
import React from "react";
import {useLanguage} from "../../hooks/LanguageContext";
import DigitInput from "../common/DigitInput";

const VehicleInfoStep3 = ({ data, errors, handleBack, handleNext, handleInputChange }) => {
    const { language } = useLanguage();

    return (
        <div className="space-y-6 mt-12 container">
            {/* First Row */}
            <div className="flex justify-center gap-2 md:gap-4 lg:gap-16">
                {/* Owner Name */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">اسم المالك</span>
                    </div>
                    <input
                        name="ownerName"
                        value={data.ownerName}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="اسم المالك"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 py-3 px-4 text-base font-medium leading-[23.52px]
                            border-primary-700 bg-bg-light placeholder:text-grayscale-400"
                    />
                </div>
                {/* Chassis Number */}

                <div className="space-y-2">
                    <DigitInput length={5} label="رقم الهيكل (اخر 5 ارقام)" name="chassisNumber" onChange={handleInputChange} />
                </div>




            </div>

            {/* Second Row */}
            <div className="flex flex-col items-center lg:flex-row justify-center gap-2 md:gap-4 lg:gap-16">
            {/* Plate Number */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">رقم اللوحة</span>
                    </div>
                    <input
                        name="plateNumber"
                        value={data.plateNumber}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="رقم اللوحة"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 py-3 px-4 text-base font-medium leading-[23.52px]
                            border-primary-700 bg-bg-light placeholder:text-grayscale-400"
                    />
                </div>

                {/* Vehicle Type */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">نوع السيارة</span>
                    </div>
                    <input
                        name="vehicleType"
                        value={data.vehicleType}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="نوع السيارة"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 py-3 px-4 text-base font-medium leading-[23.52px]
                            border-primary-700 bg-bg-light placeholder:text-grayscale-400"
                    />
                </div>
            </div>

            {/* Third Row */}
            <div className="flex justify-center gap-2 md:gap-4 lg:gap-16">




                {/* Model */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">الموديل</span>
                    </div>
                    <input
                        name="vehicleModel"
                        value={data.vehicleModel}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="الموديل"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 py-3 px-4 text-base font-medium leading-[23.52px]
                            border-primary-700 bg-bg-light placeholder:text-grayscale-400"
                    />
                </div>

                {/* Color */}
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">اللون</span>
                    </div>
                    <input
                        name="vehicleColor"
                        value={data.vehicleColor}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="اللون"
                        className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 py-3 px-4 text-base font-medium leading-[23.52px]
                            border-primary-700 bg-bg-light placeholder:text-grayscale-400"
                    />
                </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex justify-between !mt-12">
                <Button onClick={handleBack}>السابق</Button>
                <Button onClick={handleNext}>التالي</Button>
            </div>
        </div>
    );
};

export default VehicleInfoStep3;
